import { isNativePlatform } from './platform';

/**
 * Get the OAuth redirect URI based on the platform
 * For web: uses the current origin
 * For mobile: uses a web URL that can redirect back to the app
 * Note: Web OAuth clients don't accept custom URL schemes, so we use a web URL
 */
export const getOAuthRedirectUri = (): string => {
  if (isNativePlatform()) {
    // For mobile apps, use a web URL that's configured in Google Cloud Console
    // This web URL will handle the OAuth callback and redirect to the app
    // You can use your production domain or a dedicated OAuth callback domain
    const mobileRedirectUri = import.meta.env.VITE_MOBILE_OAUTH_REDIRECT_URI;
    
    if (mobileRedirectUri) {
      return mobileRedirectUri;
    }
    
    // Fallback: Use the same origin (works if app is served via web)
    // For production, set VITE_MOBILE_OAUTH_REDIRECT_URI to your web domain
    return window.location.origin + '/oauth/callback';
  }
  
  // For web, use the current origin
  return window.location.origin;
};

/**
 * Get OAuth callback URL from the current URL
 * Extracts the authorization code from the URL query parameters
 */
export const getOAuthCallbackCode = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('code');
};

/**
 * Get OAuth error from the current URL
 */
export const getOAuthError = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('error');
};

